import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import CalendarIcon from "../Icons/CalendarIcon";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  buttonText: {
    paddingLeft: theme.spacing(1)
  },
  button: {
    fontSize: "0.75rem",
    fontWeight: 500,
    width: 226
  }
}));

function ReserveTimeButton(props) {
  const classes = useStyles();
  const { ...buttonProps } = props;
  const { t } = useTranslation();
  return (
    <Button
      variant="text"
      color="primary"
      {...buttonProps}
      className={classes.button}
    >
      <CalendarIcon size="small" color="primary" />
      <span className={classes.buttonText}>
        {t("learningPathListView.reserveTimeButton")}
      </span>
    </Button>
  );
}

export default ReserveTimeButton;

ReserveTimeButton.propTypes = {
  onClick: PropTypes.func
};
